const config = process.env.APP_SETTINGS;
export { config }


// WEBPACK FOOTER //
// ./src/config/index.js